import { $el } from '../ui/elements';
import { UIViewSpec } from '../ui/view';
import { YClipObject } from '../y/clip';
import { YForm } from '../y/form';
import { EDBlock } from './block';
import { EDBlockList } from './blocklist';
import { EDBlockContainer, EDButtonSpec } from './editor';

export abstract class EDContainerBlock<Block extends { type: string }, Extra extends {} = {}> extends EDBlock<Extra> implements EDBlockContainer<Extra> {
    protected list: EDBlockList<Block, Extra>

    constructor(form: YForm, parent: EDBlockContainer<Extra>, name: string, properties: UIViewSpec = $el.DIV()) {
        const editor = parent.editor;
        const list = new EDBlockList(editor, b => editor.makeBlock(b, this));
        form.add('blocks', list.blocks);
        super(form, parent, name, properties);

        this.list = list;
    }

    override getButtons(): EDButtonSpec[] {
        return this.list.getButtons();
    }

    getChildButtons(block: EDBlock<Extra>): EDButtonSpec[] {
        return this.list.getButtons(block);
    }

    insertBlock(rel: EDBlock<Extra> | undefined, anchor: UIViewSpec) {
        this.list.insertBlock(rel, anchor);
    }

    removeBlock(block: EDBlock<Extra>) {
        this.list.removeBlock(block);
    }

    get children() {
        return this.list.blocks.views;
    }

    override doPaste(object: YClipObject, editor_block?: EDBlock<Extra>): void {
        if(object[0] == 'ed-block') {
            const blocks = this.list.blocks;
            const entry = blocks.insertBefore(object[1], editor_block && blocks.findView(editor_block));
            this.editor.selectObject(entry?.view);
        } else {
            this.parent.doPaste(object, this);
        }
    }
}
